import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e24172e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = { class: "mb-10" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-10 fs-15 fs-md-16 fs-lg-18" }, " Asistencia de estudiantes por grupo ", -1))
const _hoisted_5 = {
  key: 0,
  class: "text-muted d-block mb-2"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "flt-student",
  class: "form-label fw-medium text-black"
}, "Estudiante", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "flt-group",
  class: "form-label fw-medium text-black"
}, "Grupo", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "flt-teacher",
  class: "form-label fw-medium text-black"
}, "Docente", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "flt-subject",
  class: "form-label fw-medium text-black"
}, "Asignatura", -1))
const _hoisted_10 = {
  class: "accordion",
  id: "groupsAccordion"
}
const _hoisted_11 = ["data-bs-target", "aria-controls"]
const _hoisted_12 = { class: "d-sm-flex align-items-center justify-content-between w-100" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "number bg-primary text-center text-white rounded-circle fs-13 fw-semibold" }
const _hoisted_15 = { class: "ms-10" }
const _hoisted_16 = { class: "text-muted ms-10" }
const _hoisted_17 = { class: "d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled" }
const _hoisted_18 = { class: "position-relative fw-medium fs-13 text-muted me-15" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-people" }, null, -1))
const _hoisted_20 = { class: "position-relative fw-medium fs-13 text-muted" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user" }, null, -1))
const _hoisted_22 = ["id"]
const _hoisted_23 = { class: "accordion-body" }
const _hoisted_24 = ["id"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "d-sm-flex align-items-center justify-content-between w-100" }
const _hoisted_27 = { class: "d-flex align-items-center sub-teacher-indent" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-play me-8" }, null, -1))
const _hoisted_29 = { class: "d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled" }
const _hoisted_30 = { class: "position-relative fw-medium fs-13 text-muted me-15" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book" }, null, -1))
const _hoisted_32 = { class: "position-relative fw-medium fs-13 text-muted" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-people" }, null, -1))
const _hoisted_34 = { class: "accordion-body" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "text-primary" }
const _hoisted_37 = { class: "d-flex align-items-center gap-2" }
const _hoisted_38 = { class: "text-muted" }
const _hoisted_39 = { class: "subject-card-body" }
const _hoisted_40 = { class: "table-responsive" }
const _hoisted_41 = { class: "text-center text-success my-2" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Cargando...", -1))
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "d-block fw-bold text-primary" }
const _hoisted_45 = { class: "subject-card-footer d-flex justify-content-end align-items-center" }
const _hoisted_46 = {
  key: 0,
  class: "text-muted fs-13"
}
const _hoisted_47 = {
  key: 0,
  class: "text-muted fs-13"
}
const _hoisted_48 = {
  key: 0,
  class: "text-muted fs-14 mt-10"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, " Vas a registrar la asistencia para: ", -1))
const _hoisted_50 = { class: "list-unstyled mb-3 small" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Grupo:", -1))
const _hoisted_52 = { key: 0 }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Asignatura:", -1))
const _hoisted_54 = { key: 1 }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Docente:", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Año académico:", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fecha de asistencia:", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Estudiantes en el grupo:", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "small text-muted" }, " Se usará la información ya cargada en la tabla (estado de asistencia, justificación y observaciones) para cada estudiante del grupo. ", -1))
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchSelect = _resolveComponent("SearchSelect")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_b_container = _resolveComponent("b-container")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.currentAcademicYearLabel)
          ? (_openBlock(), _createElementBlock("small", _hoisted_5, [
              _createTextVNode(" Año académico actual: "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.currentAcademicYearLabel), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_b_row, { class: "g-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, { md: "3" }, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_group, null, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _createVNode(_component_SearchSelect, {
                      id: "flt-student",
                      modelValue: _ctx.filters.studentId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.studentId) = $event)),
                      options: _ctx.studentOptions,
                      placeholder: "Seleccione el estudiante",
                      onChange: _ctx.onFiltersChange
                    }, null, 8, ["modelValue", "options", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_b_col, { md: "3" }, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_group, null, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _createVNode(_component_SearchSelect, {
                      id: "flt-group",
                      modelValue: _ctx.filters.courseGroupId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.courseGroupId) = $event)),
                      options: _ctx.groupOptions,
                      placeholder: "Seleccione el grupo",
                      onChange: _ctx.onFiltersChange,
                      disabled: _ctx.sessionId > 0
                    }, null, 8, ["modelValue", "options", "onChange", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_b_col, { md: "3" }, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_group, null, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createVNode(_component_SearchSelect, {
                      id: "flt-teacher",
                      modelValue: _ctx.filters.teacherId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.teacherId) = $event)),
                      options: _ctx.teacherOptions,
                      placeholder: "Todos los docentes",
                      onChange: _ctx.onFiltersChange,
                      disabled: _ctx.sessionId > 0
                    }, null, 8, ["modelValue", "options", "onChange", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_b_col, { md: "3" }, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_group, null, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _createVNode(_component_SearchSelect, {
                      id: "flt-subject",
                      modelValue: _ctx.filters.subjectId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.subjectId) = $event)),
                      options: _ctx.subjectOptions,
                      placeholder: "Todas las asignaturas",
                      onChange: _ctx.onFiltersChange,
                      disabled: _ctx.sessionId > 0
                    }, null, 8, ["modelValue", "options", "onChange", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupsForTree, (grp, gIdx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: grp.groupId,
            class: "accordion-item border-0"
          }, [
            _createElementVNode("button", {
              class: "accordion-button d-block w-100 text-start text-black fs-14 fs-md-15 fw-medium rounded-0 bg-white border-0",
              type: "button",
              "data-bs-toggle": "collapse",
              "data-bs-target": `#grp-${grp.groupId}`,
              "aria-controls": `grp-${grp.groupId}`
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(gIdx + 1), 1),
                  _createElementVNode("span", _hoisted_15, [
                    _createTextVNode(_toDisplayString(grp.groupName || ("Grupo " + grp.groupId)) + " ", 1),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(grp.courseName || "N/D") + " - " + _toDisplayString(grp.headquarterName || "Sin sede") + " - " + _toDisplayString(grp.academicYearNameDisplay || "N/D"), 1)
                  ])
                ]),
                _createElementVNode("ul", _hoisted_17, [
                  _createElementVNode("li", _hoisted_18, [
                    _hoisted_19,
                    _createTextVNode(" " + _toDisplayString(grp.counts.total) + " estudiantes ", 1)
                  ]),
                  _createElementVNode("li", _hoisted_20, [
                    _hoisted_21,
                    _createTextVNode(" " + _toDisplayString(grp.teachers.length) + " profesores ", 1)
                  ])
                ])
              ])
            ], 8, _hoisted_11),
            _createElementVNode("div", {
              id: `grp-${grp.groupId}`,
              class: "accordion-collapse collapse",
              "data-bs-parent": "#groupsAccordion"
            }, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", {
                  class: "accordion",
                  id: `teachersAccordion-${grp.groupId}`
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grp.teachers, (tch) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: tch.teacherKey,
                      class: "accordion-item border-0"
                    }, [
                      _createElementVNode("button", {
                        class: "accordion-button d-block w-100 text-start text-black fs-13 fw-medium rounded-0 bg-white border-0",
                        type: "button",
                        onClick: ($event: any) => (_ctx.toggleTeacher(grp.groupId, tch.teacherKey))
                      }, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _createElementVNode("span", null, _toDisplayString(tch.teacherLabel || "Docente sin nombre"), 1)
                          ]),
                          _createElementVNode("ul", _hoisted_29, [
                            _createElementVNode("li", _hoisted_30, [
                              _hoisted_31,
                              _createTextVNode(" " + _toDisplayString(tch.subjects.length) + " materias ", 1)
                            ]),
                            _createElementVNode("li", _hoisted_32, [
                              _hoisted_33,
                              _createTextVNode(" " + _toDisplayString(grp.counts.total) + " estudiantes ", 1)
                            ])
                          ])
                        ])
                      ], 8, _hoisted_25),
                      _withDirectives(_createElementVNode("div", _hoisted_34, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tch.subjects, (sub) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: sub.assignmentId,
                            class: "subject-card mb-10"
                          }, [
                            _createElementVNode("div", {
                              class: "subject-card-header subject-header-clickable",
                              onClick: ($event: any) => (_ctx.toggleSubject(grp.groupId, tch.teacherKey, sub.assignmentId))
                            }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("strong", _hoisted_36, _toDisplayString(sub.subjectName), 1)
                              ]),
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("small", _hoisted_38, " Estudiantes en el grupo: " + _toDisplayString(grp.counts.total), 1),
                                _createElementVNode("i", {
                                  class: "flaticon-play",
                                  style: _normalizeStyle({
                            transform: _ctx.isSubjectExpanded(grp.groupId, tch.teacherKey, sub.assignmentId)
                              ? 'rotate(90deg)'
                              : 'rotate(0deg)',
                            transition: 'transform 0.15s ease'
                          })
                                }, null, 4)
                              ])
                            ], 8, _hoisted_35),
                            _withDirectives(_createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                  _createVNode(_component_b_table, {
                                    items: sub.items,
                                    fields: _ctx.groupTableHeaders,
                                    class: "table table-sm table-ultra-compact text-nowrap mb-0",
                                    hover: "",
                                    small: "",
                                    "primary-key": "StudentId"
                                  }, {
                                    "table-busy": _withCtx(() => [
                                      _createElementVNode("div", _hoisted_41, [
                                        _createVNode(_component_b_spinner, { class: "align-middle" }),
                                        _hoisted_42
                                      ])
                                    ]),
                                    "cell(StudentName)": _withCtx((row) => [
                                      _createElementVNode("a", {
                                        onClick: _withModifiers(($event: any) => (_ctx.editStudent(row.item.StudentId)), ["prevent"]),
                                        class: "cursor-pointer text-black fw-bold text-decoration-none"
                                      }, [
                                        _createElementVNode("span", _hoisted_44, _toDisplayString(row.item.StudentName), 1)
                                      ], 8, _hoisted_43)
                                    ]),
                                    "cell(StatusCode)": _withCtx((row) => [
                                      _createVNode(_component_b_form_select, {
                                        modelValue: sub.items[row.index].StatusCode,
                                        "onUpdate:modelValue": ($event: any) => ((sub.items[row.index].StatusCode) = $event),
                                        options: _ctx.attendanceStatusOptions,
                                        size: "sm",
                                        class: "form-select-sm"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                    ]),
                                    "cell(IsJustified)": _withCtx((row) => [
                                      _createVNode(_component_b_form_checkbox, {
                                        modelValue: sub.items[row.index].IsJustified,
                                        "onUpdate:modelValue": ($event: any) => ((sub.items[row.index].IsJustified) = $event),
                                        name: "chk-justified"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    "cell(JustificationNote)": _withCtx((row) => [
                                      _createVNode(_component_b_form_input, {
                                        modelValue: sub.items[row.index].JustificationNote,
                                        "onUpdate:modelValue": ($event: any) => ((sub.items[row.index].JustificationNote) = $event),
                                        size: "sm",
                                        placeholder: "Opcional"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1032, ["items", "fields"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_45, [
                                _createVNode(_component_b_button, {
                                  type: "button",
                                  class: "btn btn-success",
                                  disabled: _ctx.table.loading,
                                  onClick: ($event: any) => (_ctx.openDialog(grp, tch, sub)),
                                  style: `--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .75rem; --bs-btn-font-size: .8rem;`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Registrar asistencia ")
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "onClick"])
                              ])
                            ], 512), [
                              [_vShow, _ctx.isSubjectExpanded(grp.groupId, tch.teacherKey, sub.assignmentId)]
                            ])
                          ]))
                        }), 128)),
                        (!tch.subjects.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, " No hay materias asignadas para este docente en el grupo. "))
                          : _createCommentVNode("", true)
                      ], 512), [
                        [_vShow, _ctx.isTeacherExpanded(grp.groupId, tch.teacherKey)]
                      ])
                    ]))
                  }), 128)),
                  (!grp.teachers.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, " No hay profesores/asignaciones académicas para este grupo. "))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_24)
              ])
            ], 8, _hoisted_22)
          ]))
        }), 128)),
        (!_ctx.groupsForTree.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, " No hay datos para mostrar (verifique filtros o el año académico actual). "))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_b_modal, {
        class: "modal fade",
        modelValue: _ctx.form.dialog,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.dialog) = $event)),
        tabindex: "-1",
        "aria-hidden": "true",
        title: "Confirmar registro de asistencia",
        "ok-disabled": "",
        "hide-footer": true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_container, {
            fluid: "",
            class: "p-15 p-sm-20 p-md-25 p-lg-30"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form, {
                id: "formModal",
                onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _hoisted_49,
                  _createElementVNode("ul", _hoisted_50, [
                    _createElementVNode("li", null, [
                      _hoisted_51,
                      _createTextVNode(" " + _toDisplayString(_ctx.form.summary.groupName || "N/D"), 1)
                    ]),
                    (_ctx.form.summary.subjectName)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_52, [
                          _hoisted_53,
                          _createTextVNode(" " + _toDisplayString(_ctx.form.summary.subjectName), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.form.summary.teacherName)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_54, [
                          _hoisted_55,
                          _createTextVNode(" " + _toDisplayString(_ctx.form.summary.teacherName), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("li", null, [
                      _hoisted_56,
                      _createTextVNode(" " + _toDisplayString(_ctx.form.summary.academicYearName || "N/D"), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _hoisted_57,
                      _createTextVNode(" " + _toDisplayString(_ctx.form.summary.sessionDate), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _hoisted_58,
                      _createTextVNode(" " + _toDisplayString(_ctx.form.summary.studentsCount), 1)
                    ])
                  ]),
                  _hoisted_59,
                  _createVNode(_component_b_row, {
                    dense: "",
                    class: "mt-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, {
                        cols: "12",
                        sm: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_button, {
                            type: "submit",
                            class: "default-btn transition border-0 fw-medium text-white w-100 pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 rounded-1 fs-md-15 fs-lg-16 bg-success",
                            disabled: _ctx.form.loading
                          }, {
                            default: _withCtx(() => [
                              (!_ctx.form.loading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_60, "Guardar asistencia"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_61, "Guardando..."))
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}